import useSaveMutation from "../../../Hooks/apis/useSaveMutaion";
import { mapRowsBySchema } from '../../../util';
import Global from "../../../Services/Common/Global";
import { apiRequest } from "../../../Services/Common/ApiRequest";
import { M_RNM_BASIC_03_Schema } from "./M_RNM_BASIC_03_Schema";


/** 안전신문고 저장 SaveAccBasic02U1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_RNM_BASIC_03_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.WorkInfo.saveAccBasic02U1, payload);
  }, options);
};